import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-career-role-detail',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './career-role-detail.component.html',
  styleUrl: './career-role-detail.component.scss'
})
export class CareerRoleDetailComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  get slug(): string {
    return this.route.snapshot.paramMap.get('slug') ?? '';
  }

  tabLink(path: string): string[] {
    return ['/admin/career-roles', this.slug, path];
  }
}